<app-tap-to-top></app-tap-to-top>
<app-header></app-header>
<!-- <div class="img">
    <img src="./assets/images/header.png" class="img-fluid" alt="images" />
</div> -->
<router-outlet></router-outlet>
<div class="footer-striper"></div>
<app-footer></app-footer>

